
export const routes = {
  ROOT: '/',
  OBJECT: '/object/:publicId'
};
